import type { ForwardedRef, RefObject } from 'react';
import { useEffect, useRef } from 'react';

/**
 * Use this hook to return a `RefObject` ref when working with a `forwardRef`.
 *
 * @internal This hook is not intended to be used outside of the library.
 */
export function useForwardedRef<T>(ref: ForwardedRef<T>): RefObject<T> {
  const forwardedRef = useRef<T>(null);

  useEffect(() => {
    if (!ref) {
      return;
    }
    if (typeof ref === 'function') {
      ref(forwardedRef.current);
    } else {
      ref.current = forwardedRef.current;
    }
  });

  return forwardedRef;
}
